/**
 * data/queryKeys — construção de chaves de cache segmentadas por tenant.
 *
 * Toda leitura via QueryProvider deve usar uma chave construída por
 * `buildQueryKey`, garantindo que `tenantId` (e, quando aplicável,
 * `businessUnitId`) prefixem a chave. Isso isola o cache por tenant/BU
 * (RNF 2.3, DD-004) — dados de tenants distintos nunca colidem.
 *
 * `area` é tipado como `string` para não acoplar este módulo ao enum
 * `DataArea` de `data/source.ts` (TASK-02); na prática recebe um `DataArea`.
 */

/** Chave de cache estável: `[tenantId, businessUnitId | null, area, params?]`. */
export type TenantQueryKey =
  | readonly [string, string | null, string]
  | readonly [string, string | null, string, unknown];

/**
 * Constrói a chave de cache prefixada por tenant/BU. `params` é anexado apenas
 * quando fornecido, mantendo chaves estáveis para listas sem parâmetros.
 */
export function buildQueryKey(
  area: string,
  tenantId: string,
  businessUnitId: string | null,
  params?: unknown,
): TenantQueryKey {
  return params === undefined
    ? [tenantId, businessUnitId, area]
    : [tenantId, businessUnitId, area, params];
}
